
import React from 'react';

const GoogleLocations = () => {
    return (
        <div>
            
        </div>
    );
};

export default GoogleLocations;